import {Component, inject} from '@angular/core';
import { Router } from '@angular/router';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
@Component({
    selector: 'system-management-menu',
    templateUrl: './system-management-menu.component.html',
    styleUrls: ['./system-management-menu.component.css'],
    standalone: false
})
export class SystemManagementMenuComponent {
  router = inject(Router)

  systemBrandingClick() {
    this.router.navigate(['dashboard/SystemManagement/branding'])
  }

  announcementsClick() {
    this.router.navigate(['dashboard/SystemManagement/Announcement/List'])
  }

  protected readonly faChevronRight = faChevronRight;
}
